import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UserDetailPage } from './UserDetailPage';

const searchSchema = z.object({
  tab: z.enum(['accounts', 'receipts', 'chat', 'referrals']).optional().default('accounts'),
});

export type UserDetailTab = z.infer<typeof searchSchema>['tab'];

export const Route = createFileRoute('/_protected/admin/users/$userId/')({
  component: UserDetailPage,
  validateSearch: searchSchema,
});
